var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from "react";
import Flex from "./Flex";
import { styled } from "../imports";
import { prop, breakpointProp } from "../utils";
var Board = function Board(props) {
  return React.createElement(Flex, _extends({
    wrap: true,
    gapType: "padding"
  }, props));
};
Board.Item = /*#__PURE__*/styled(Flex.Item, {
  target: "css-zvl7y90"
})(breakpointProp(function (val, rawVal) {
  return "width:" + 100 * rawVal + "%";
}), ";", prop("width", function (val, rawVal) {
  return "width:" + 100 * rawVal + "%";
}), ";", prop("offset", function (val, rawVal) {
  return "margin-left:" + 100 * rawVal + "%";
}), ";");
Board.Item.displayName = "Board.Item";
export default Board;